import { Pressable, Text, View } from "react-native";
import { Avatar } from "@/shared/components/ui/avatar";
import { FollowButton } from "@/features/profile/components/follow-button";
import { Link } from "expo-router";

interface UserListItemProps {
  userId: string;
  name: string;
  username: string;
  avatarUrl: string | null | undefined;
  avatarSize?: number;
}

export function UserListItem({
  userId,
  name,
  username,
  avatarUrl,
  avatarSize = 48,
}: UserListItemProps) {
  return (
    <View className="flex-row items-center gap-3">
      <Link href={`/user/${userId}`} asChild>
        <Pressable
          className="flex-1 flex-row items-center gap-3 active:opacity-70"
          accessible={true}
          accessibilityRole="button"
          accessibilityLabel={`${name}, @${username}`}
          accessibilityHint="Toque para ver perfil"
        >
          <Avatar url={avatarUrl} name={name} size={avatarSize} />
          <View>
            <Text className="text-foreground text-base font-semibold">
              {name}
            </Text>
            <Text className="text-muted-foreground text-sm">@{username}</Text>
          </View>
        </Pressable>
      </Link>
      <FollowButton userId={userId} />
    </View>
  );
}
